<template>
  <div class="flex items-center border shadow-md rounded-lg py-2 mt-4">
    <img class="w-16 rounded-lg" :src="food.imgurl" alt=""
         @error="$event.target.src = require('@/assets/img/food_placeholder.png')">
    <div class="mr-2">
      <h1 class="text-sm">{{ food.kala_Name }}</h1>
      <h3 class="text-xs mt-1 text-gray-600">
        قیمت:
        <span :class="food.isNegative === -1 ? 'text-theme-500' : 'text-ColorNerkh font-bold'">
          <span>{{ $helper.priceFormatter(food.nerkh / 10, false) }}</span>
        </span>
        تومان
      </h3>
    </div>
    <div class="flex items-center text-xs ml-4 mr-auto">
      <span>تعداد</span>
      <div class="bg-ColorNerkh py-1 px-2 rounded-lg text-sm mr-2">
        <span>{{ food.quantity }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FactorFoodCard",
  props: ['food'],
}
</script>

<style scoped>

</style>